 

export enum ALIVE_BATTERY_STATUS
{
    LOW,
    GOOD
}


export enum CHECKIN_MOODE
{
    CHECKIN = 0x0,
    ADD_CARD = 0x01,
    RECHECKIN = 0x02

}

export enum CHECKIN_RESULT 
{
    NEW_CHECKIN_SUCCESS = 1,
    NEW_CHECKIN_FAILED,

    ADD_CARD_SUCCESS,
    ADD_CARD_FAILED,

    MOBILE_KEY_SUCCESS,
    MOBILE_KEY_FAILED,

    READ_CARD_SUCCESS,
    READ_CARD_FAILED,

    DELETE_CARD_SUCCESS,
    DELETE_CARD_FAILED,
}


export enum NOTIFICATION_TYPE
{
    DOOR_EVENTS = 0x0,
    IARESULTS = 0x01,
    CACHE_DATA = 0x02,
    ALIVE_DATA = 0x03,
    CHAT_DATA = 0x20, 
}


export enum ALIVE_LOCK_STATE
{
        UNKNOW = 0x0,
        NORMAL_CLOSE = 0x01,
        OFFICE_FIRST = 0x02,
        OFFICE = 0x03,
        MUR = 0x04,
        DND_LOGICAL_PRIVACY = 0x05,
        MECHANICAL_PRIVACY = 0x06,
        BLOCKED = 0x07


}

export enum ALIVE_LOCK_ALARM {
        NO_ALARM = 0x0,
        DOOR_CONTACT_CLOSED = 0x0,

        INTERNAL_HANDLE = 0x01,
        OUTSIDE_HANDLE = 0x02,
        INTERNAL_CLOCK = 0x03,

        DOOR_CONTACT_OPENED_PREALARM = 0x04,
        DOOR_CONTACT_OPENED_ALARM = 0x05
}



export enum TOAST_TYPE {
    INFO = 0x0,
    WARNING = 0x1, 
    SUCCESS = 0x02,
    ERROR = 0x03,
    WAIT = 0x04 
}


export enum OP_CODE {
 
    GRANT_OPEN = 1,
    GRANT_BLOCK_OR,
    GRANT_PRIV_OR,
    GRANT_UNLOCKED_OK,
    GRANT_DUMMY,



    GRANT_CANCELLING,
    GRANT_BLOCKED,
    GRANT_OFFICE = 9,
    SYS_ANS_GRANT_BACK_OF_BY_FREE_PASSAGE = 22,

    REJECT_UNKNOWN = 128,
    REJECT_NO_OPEN,
    REJECT_NO_AUT,
    REJECT_INI_DATE,
    REJECT_EXP_DATE,
    NOPIN,
    BADPIN,
    REJECT_ONE_SHOT_EXP,
    REJECT_BLOCKED,
    REJECT_OUTSHIFT,
    REJECT_USR_DISABLED,
    
    SYS_ANS_DO_NOT_APP_IS_IN_OFFICE = 123,
    SYS_ANS_INTEGRA_DATA_NOK = 135,
    SYS_ANS_CMD_NOT_WELL_GEN =  137,
    SYS_ANS_LOCK_NOT_OFFICE_ENABLED =  138,
    SYS_ANS_DO_NOT_APP_IS_BLOCK =  143,
    SYS_ANS_DO_NOT_APP_IS_MECH_PRIV =  144,
    SYS_ANS_ALREADY_IN_DND =  145,
    SYS_ANS_DO_NOT_APP_IS_NOT_IN_THIS_STATE =  146,
    SYS_ANS_DO_NOT_APP_IS_IN_SEC_CLOSE =  147,
    SYS_ANS_DO_NOT_APP_IS_IN_OFFIRST =  148
  }



